import * as React from 'react';
import {
    Create,
    TextInput,
    SimpleForm,
    BooleanInput,
    NumberInput,
    required,
} from 'react-admin';

const req = [required()];

const EntityCreate = () => {
    return (
        <>
            {/* @ts-ignore */}
            <Create resource="logix_packings">
                <SimpleForm sx={{ maxWidth: { xl: '80%' } }}>
                    <NumberInput
                        source="service_id"
                        min={1}
                        step={1}
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <TextInput
                        source="title"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <TextInput
                        source="title_short"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <TextInput
                        source="type"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <TextInput
                        source="group"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <TextInput
                        source="unit"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <NumberInput
                        source="unit_code"
                        min={1}
                        step={1}
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <BooleanInput source="active" fullWidth />
                    <BooleanInput source="is_transport" fullWidth />
                    <TextInput
                        source="helper"
                        fullWidth
                        multiline
                        maxRows={10}
                    />
                </SimpleForm>
            </Create>
        </>
    );
};

export default EntityCreate;
